export class SeededRandom {
  private state: number;

  constructor(seed: string | number) {
    this.state = typeof seed === 'number' ? seed >>> 0 : hashSeed(seed);
    if (this.state === 0) {
      this.state = 0x9e3779b9;
    }
  }

  next() {
    this.state += 0x6d2b79f5;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  integer(min: number, max: number) {
    if (max < min) {
      throw new Error(`Invalid random range: ${min}..${max}`);
    }
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  pick<T>(items: readonly T[]) {
    if (items.length === 0) {
      throw new Error('Cannot pick from an empty array');
    }
    return items[this.integer(0, items.length - 1)];
  }
}

export function getSeedFromUrl(defaultSeed = 'm1-default') {
  const params = new URLSearchParams(window.location.search);
  const seed = params.get('seed')?.trim();
  return seed && seed.length > 0 ? seed : defaultSeed;
}

function hashSeed(seed: string) {
  let hash = 2166136261;
  for (let index = 0; index < seed.length; index += 1) {
    hash ^= seed.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return hash >>> 0;
}
